import { createStore } from 'satcheljs';
export default createStore('confettiOption', {
    isEnabled: null,
});
//# sourceMappingURL=store.js.map